module.exports = __webpack_public_path__ + "img/factor_c.9cc4f2a5.svg";